const servicesLinks = {
  enterprise_technologies: {
    name: "ENTERPRISE TECHNOLOGIES AND SERVICES",
    links: {
      subLink1: [
        { name: "Infor", link: "/services/infor" },
        { name: "SAP", link: "/services/sap" },

        {
          name: "Oracle",
          link: "/services/oracle_and_id_edwards",
        },
        { name: " Microsoft", link: "/services/microsoft" },
        { name: "Odoo", link: "/services/odoo" },
      ],
      subLink2: [
        {
          name: "ERP Consulting",
          subLink: [
            { name: "Infor", link: "/services/infor" },
            { name: "SAP", link: "/services/sap" },
            { name: "Odoo", link: "/services/odoo" },
          ],
        },

        // {
        //   name: " Manufacturing Execution Systems",
        //   link: "/services/manufacturing_execution_systems",
        // },
        {
          name: "Application  development",
          link: "/services/applications_management",
        },
        { name: "IV&V QA", link: "/services/testing" },
        {
          name: "Product Lifecycle Management",
          link: "/services/product_lifecycle_management",
        },
        {
          name: "Customer Relationship Management",
          link: "/services/customer_relationship_management",
        },
        {
          name: "Supply Chain Management",
          link: "/services/supply_chain_management",
        },
        {
          name: "Environmental Social & Governance",
          link: "/services/environmental_social_governance",
        },
        { name: "IT Transformation", link: "/services/it_transformation" },
      ],
      InforLinks: [
        {
          name: "ERP Solutions",
          link: "",

          subLink: [
            {
              name: "Infor LN ",
              link: "",
            },
            {
              name: "Infor CloudSuite Industrial (CSI)",
              link: "",
            },
            {
              name: "Infor M3",
              link: "",
            },
          ],
        },
        {
          name: "Supply Chain Planning",
          link: "",

          subLink: [
            {
              name: "Infor Supply Chain Planning",
              link: "",
            },
          ],
        },
        {
          name: "Infor Warehouse Management",
          link: "",
        },

        {
          name: "Customer Experience ",
          link: "",

          subLink: [
            {
              name: "Infor Rhythm for Commerce",
              link: "",
            },
            {
              name: "Infor CPQ",
              link: "",
            },
            {
              name: "Infor CRM",
              link: "",
            },
          ],
        },
        {
          name: "Product Lifecycle Management",
          link: "",

          subLink: [
            {
              name: "Infor PLM for Process",
              link: "",
            },
            {
              name: "Infor PLM for Fashion",
              link: "",
            },
          ],
        },

        {
          name: "Infor (OS)",
          link: "",
        },
      ],
    },
  },
  staffAugLinks: {
    name: "Services",
    links: {
      subLink1: [
        {
          name: "Staffing Services",
          isCategory: true,
          children: [
            { name: "Permanent Staffing", link: "/services/staffing-services/permanent-staffing" },
            { name: "Contract Staffing", link: "/services/staffing-services/contract-staffing" },
            { name: "Direct Hire", link: "/services/staffing-services/direct-hire" },
            { name: "Contract To Hire", link: "/services/staffing-services/contract-to-hire" },
            { name: "Statement of work", link: "/services/staffing-services/statement-of-work" },
          ],
        },
        {
          name: "ERP Services",
          isCategory: true,
          children: [
            { name: "Infor", link: "/services/erpservices/infor" },
            { name: "SAP", link: "/services/erpservices/sap" },
            { name: "Odoo", link: "/services/erpservices/odoo" },
            { name: "Oracle", link: "/services/erpservices/oracle" },
            { name: "Epicor", link: "/services/erpservices/epicor" },
            { name: "IFS", link: "/services/erpservices/ifs" },
          ],
        },
        {
          name: "Technology",
          isCategory: true,
          children: [
            { name: "AI & ML", link: "/services/technology/ai-ml" },
            { name: "Cloud", link: "/services/technology/cloud" },
            { name: "CyberSecurity", link: "/services/technology/cybersecurity" },
          ],
        },
      ],
    },
  },
  Products: {
    name: "PRODUCTS",
    links: {
      subLink1: [
        // { name: "Finsta", link: "/services/finsta" },

        // { name: "IFCA", link: "https://ifca.asia/" },

        {
          name: " Infor MES (Manufacturing Execution System)",
          link: "/services/mes",
        },
      ],

      subLink2: [
        // { name: "Mobillor", link: "/services/mobillor" },
        {
          name: "Office24by7",
          link: "/services/Office24by7",
        },
        { name: "Prokraya", link: "/services/Prokraya" },
      ],
    },
  },
};
const industriesLinks = {
  industries_1: {
    links: {
      subLink1: [
        { name: "Automotive", link: "/industries/automotive" },
        { name: "Construction", link: "/industries/construction" },
        { name: "Energy", link: "/industries/energy" },
        { name: "Equipment", link: "/industries/equipment" },
        { name: "Food and Beverage", link: "/industries/food_and_beverage" },
      ],
    },
  },
  industries_2: {
    links: {
      subLink1: [
        {
          name: "Industrial Machinery",
          link: "/industries/industrial_macinery_and_equipment",
        },
        {
          name: "Industrial Manufacturing",
          link: "/industries/industrial_manufacturing",
        },
        {
          name: "Life Sciences",
          link: "/industries/life_sciences",
        },
        {
          name: "High Tech and Electronics",
          link: "/industries/high_tech_and_electrinics",
        },
      ],
    },
  },
};

const insightsLinks = {
  insights_1: {
    links: {
      subLink1: [
        { name: "About us", link: "/insights/aboutus" },
        // { name: "Infor Training", link: "/insights/infor-training" },
        // { name: "Leadership", link: "/insights" },
        // { name: "Customer Stories", link: "/insights/customerstories" },
        { name: "Webinar", link: "/insights/webinar" },
        // { name: " Blog", link: "/insights/blog" },
      ],
    },
  },
};

const partners_allianzes_Links = {
  partners_allianzes_1: {
    links: {
      subLink1: [
        { name: "Partners", link: "/partner_allianzes/partner" },
        { name: "Alliances", link: "/" },
      ],
    },
  },
};

export {
  servicesLinks,
  industriesLinks,
  insightsLinks,
  partners_allianzes_Links,
};